import React from 'react';

const ToolTipText = ({text}) => {
  return (
    <span style={{color:'#FFF', fontSize:'14px'}}>{text}</span>
  )
}

export default ToolTipText;